/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Statistic from 'admin/components/Statistic.jsx';

import './styles/DistrictStatistics.scss';

type Props = {
  organizationId: number,
  organization?: {
    statistics: {
      class_count: number,
      teacher_count: number,
      message_count: number,
      subscriber_count: number,
    },
  },
};

const DistrictStatistic = (props) =>
  <Statistic block valueWeight="light" nameColor="thunder" size="xxxxlarge" {...props} />;

function DistrictStatistics(props: Props) {
  const { organization } = props;

  if (!organization) {
    return <div className="DistrictStatistics" />;
  }

  const { statistics } = organization;

  const stats = {
    teacher_count: statistics ? statistics.teacher_count : 0,
    subscriber_count: statistics ? statistics.subscriber_count : 0,
    class_count: statistics ? statistics.class_count : 0,
    message_count: statistics ? statistics.message_count : 0,
  };

  return (
    <div className="DistrictStatistics">
      <DistrictStatistic name="Teachers" value={stats.teacher_count} />
      <DistrictStatistic name="Participants" value={stats.subscriber_count} />
      <DistrictStatistic name="Classes" value={stats.class_count} />
      <DistrictStatistic name="Announcements (past 90 days)" value={stats.message_count} />
    </div>
  );
}

const withOrganizationStatistics = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      statistics {
        teacher_count
        class_count
        message_count
        subscriber_count
      }
    }
  }`,
  {
    options: ({ organizationId }) => ({
      variables: { organizationId: [organizationId] },
    }),
    props: ({ data }) => ({
      organization: data.organizations ? data.organizations[0] : null,
      ...data,
    }),
  }
);

export { DistrictStatistics };
export default withOrganizationStatistics(DistrictStatistics);



// WEBPACK FOOTER //
// ./src/admin/components/DistrictStatistics.jsx